import React, {StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Error404 from './pages/error404';
import Home from './pages/home';
import Experiences from './pages/experiences';
import Education from './pages/education';
import NavBar from './components/navbar';
import Footer from './components/footer';

import { LanguageProvider } from './components/languageContext'; // Importez le fournisseur de contexte de langue
import './utils/general.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Test from './pages/test';
import Profil from './pages/profil';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <NavBar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/education" element={<Education />} />
              <Route path="/profil" element={<Profil />} />
              <Route path="/test" element={<Test />} />
              <Route path="*" element={<Error404 />} />
            </Routes>
          </main>
          <Footer />
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  </StrictMode>,
);
  